import { Component, Input, Output, EventEmitter, OnInit, SimpleChanges, OnChanges } from '@angular/core';

import { MemberService } from './../../../../../rest/api/member.service';
import { AuthService } from './../../../../../services/auth.service';
import { HelperService } from './../../../../../services/helper.service';
import _ from 'lodash';
import { DebugRenderer2 } from '@angular/core/src/view/services';

@Component({
  selector: 'app-edit-matter-tag',
  templateUrl: './edit-matter-tag.component.html',
  styleUrls: ['./edit-matter-tag.component.scss']
})
export class EditMatterTagComponent implements OnInit, OnChanges {
  @Input() spaceData;
  @Input() mediaData;
  @Input() selectedMedia;
  @Input() snapshotListData;
  @Output() editMediaEmit = new EventEmitter();
  @Output() modalCloseSnapshotEmit = new EventEmitter();
  @Output() highlightReelAddedEmit = new EventEmitter();
  @Output() deleteSnapshotEmit = new EventEmitter();

  accessToken: any;
  selectedSnapshotData = [];
  errMessage: any;
  errors = [];
  successMessage: any;
  submitted = false;
  singleSnapshot: any;
  isSetModalClicked = false;
  selectedAll = false;
  isSnapshotModalOpen = false;

  constructor(
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
  }

  ngOnInit() {
    // $(document).on('show.bs.modal', '.modal', function() {
    //   const zIndex = 1040 + (10 * $('.modal:visible').length);
    //   $(this).css('z-index', zIndex);
    //   // tslint:disable-next-line:only-arrow-functions
    //   setTimeout(function() {
    //       $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
    //   }, 0);
    // });

  }

  closeModal() {
    this.snapshotListData = _.map(this.snapshotListData, (res) => {
      res.selected = false;
      return res;
    });
    this.modalCloseSnapshotEmit.emit(undefined);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.snapshotListData && changes.snapshotListData.currentValue) {
      this.snapshotListData = _.map(this.snapshotListData, (res) => {
        res.selected = false;
        return res;
      });
    }
  }

  selectDeselectAllSnapshot() {
    this.selectedAll = !this.selectedAll;
    this.snapshotListData = _.map(this.snapshotListData, (res) => {
      res.selected = this.selectedAll;
      // if (!res.highlight_reel) {
      // }
      return res;
    });
  }

  selectDeselectSnapshot(snapshot) {
    // if (snapshot.highlight_reel) {
    //   return;
    // }
    this.snapshotListData = _.map(this.snapshotListData, (res) => {
      if (res.uuid === snapshot.uuid) {
        res.selected = !res.selected;
      }
      return res;
    });

    const snapshotDataSelected = _.filter(this.snapshotListData, {selected: true});
    // const snapshotListData = _.filter(this.snapshotListData, {highlight_reel: false});
    if (snapshotDataSelected.length === this.snapshotListData.length) {
      this.selectedAll = true;
    } else {
      this.selectedAll = false;
    }
  }

  addHighlightReelSnapshot() {
    const snapshotData = _.filter(this.snapshotListData, {selected: true, highlight_reel: false});
    if (snapshotData.length === 0) {
      this.errMessage = 'Please select at least one image.';
      return;
    }
    if (this.submitted) {
      return;
    }
    this.submitted = true;
    const snapshotArray = [];
    let i;
    for (i = 0; i < snapshotData.length; i++) {
      snapshotArray.push(snapshotData[i].uuid);
    }
    const data = {
      snapshot_id: snapshotArray
    };
    this.postHighlightReel(data, snapshotArray);
  }

  postHighlightReel(data, snapshotArray) {
    let formData;
    formData = data;
    formData = this.helperService.updateJsonFormat(formData);
    this.memberService.postHighlightReel({
      Authorization: this.accessToken,
      body: formData
    }).subscribe((response: any) => {
      this.submitted = false;
      this.successMessage = 'Highlight reel has been added.';
      this.highlightReelAddedEmit.emit({ response: response && response.data ? response.data : [], snapshotArray});
      setTimeout(() => {
        this.resetValues();
      }, 2000);
    }, err => {
      this.handleErrors(err);
    });
  }

  resetValues() {
    this.errors = [];
    this.successMessage = undefined;
    this.errMessage = undefined;
  }

  handleErrors(err) {
    if (err.error && err.error.errors) {
      this.errors = err.error.errors;
    } else if (err.error && err.error.error) {
      this.errMessage = err.error.error;
    } else {
      this.errMessage = 'There was error while adding hightlightreel.';
    }
    this.submitted = false;
    setTimeout(() => {
      this.resetValues();
    }, 2000);
  }

  countSelectedPhotos() {
    const snapshotData = _.filter(this.snapshotListData, {selected: true, highlight_reel: false});
    return snapshotData.length;
  }

  countSelectedPhotosForDelete() {
    const snapshotData = _.filter(this.snapshotListData, {selected: true});
    return snapshotData.length;
  }

  onClickOutside(event: any) {
    if (event && event.value === true) {
      this.modalCloseSnapshotEmit.emit(undefined);
    }
  }

  modalCloseDeleteSnapshotEmit(response) {
    if ($('#deleteSnapshotModal')) {
      $('#deleteSnapshotModal').modal('hide');
    }
  }



  deleteSnapshot() {
  //  $('#deleteSnapshotModal').modal('show');
  //  $('#deleteSnapshotModal').css('display', 'block');
  //  $('#deleteSnapshotModal').css('opacity', '5');
  //  this.isSnapshotModalOpen = !this.isSnapshotModalOpen;
    const snapshotData = _.filter(this.snapshotListData, {selected: true});
    if (snapshotData.length === 0) {
      return;
    }
    this.deleteSnapshotEmit.emit(snapshotData);
  }

}
